import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Divider, Drawer, Hidden, List } from '@mui/material';
import { useRouter } from 'next/router';

import { makeStyles } from '@mui/styles';
import i18next from 'i18next';
import MobileMenuNavItem from './MobileMenuNavItem';
import LangDropdown from './LangDropdown';
import useFeaturePages from 'hooks/useFeaturePages';
import useSolutionPages from 'hooks/useSolutionPages';

const useStyles = makeStyles(theme => ({
  root: {},
  mobileDrawer: {
    width: 250,
  },

  linkTree: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.text.primary,
    textTransform: 'uppercase',
  },
}));

function MobileMenu({ openMobile, onMobileClose }) {
  const classes = useStyles();
  const router = useRouter();
  const lang = router.query.lang || 'en';
  const featurePages = useFeaturePages();
  const solutionPages = useSolutionPages();

  const links = [
    { lan: 'en', link: `/en/security`, title: 'Security' },
    {
      title: 'Features',
      lan: 'en',
      pages: featurePages,
    },
    {
      link: `/${lang}#solutions`,
      title: i18next.t('main_menu.solutions', 'Solutions'),
      pages: lang === 'en' ? solutionPages : undefined,
    },
    { link: `/${lang}/contact`, title: i18next.t('main_menu.contact', 'Contact') },
    { link: `/${lang}/pricing`, title: i18next.t('main_menu.pricing', 'Pricing') },
  ];

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line
  }, [router.pathname]);

  const content = (
    <Box height="100%" display="flex" flexDirection="column" className={classes.root} pt={2} px={2}>
      <div style={{ width: 35 }}>
        <LangDropdown lang={lang} />
      </div>
      <Box>
        <List>
          {links.map(({ link, title, pages, lan }, index) => {
            if (lan && lan !== lang) {
              return null;
            }

            if (pages) {
              return (
                <React.Fragment key={index}>
                  <span className={classes.linkTree}>{title}</span>
                  <List>
                    {pages.map(({ link, title, pages }, subLinkIndex) => (
                      <Box key={`${index}-${subLinkIndex}`} ml={2}>
                        <MobileMenuNavItem title={title} link={link} variant={'secondary'} />
                      </Box>
                    ))}
                  </List>
                  <Box my={1}>
                    <Divider />
                  </Box>
                </React.Fragment>
              );
            }

            return (
              <React.Fragment key={index}>
                <MobileMenuNavItem title={title} link={link} />
                <Box my={1}>
                  <Divider />
                </Box>
              </React.Fragment>
            );
          })}
        </List>
      </Box>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor={lang === 'he' ? 'left' : 'right'}
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary">
          {content}
        </Drawer>
      </Hidden>
    </>
  );
}

MobileMenu.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default MobileMenu;
